import React from 'react'

import './style.styl'

const FakeEmailWindow = ({ from, address, subject, children }) => (
  <div className="fake-email-window">
    <div className="fake-email-window-title-bar">
      <div className="fake-email-window-title-bar-dot" />
      <div className="fake-email-window-title-bar-dot" />
      <div className="fake-email-window-title-bar-dot" />
    </div>
    <div className="fake-email-window-title-container">
      <span className="fake-email-window-title">From: </span>
      <strong>{from}</strong>
      {address && <span className="fake-email-address">{` <${address}>`}</span>}
    </div>
    <div className="fake-email-window-title-container">
      <span className="fake-email-window-title">Subject: </span>
      {subject}
    </div>
    <div className="fake-email-window-content"><base target="_blank"/>{children}</div>
  </div>
)

export default FakeEmailWindow



// WEBPACK FOOTER //
// ./src/scripts/components/shared/FakeEmailWindow/index.js